import React, { Component, Fragment } from 'react';
import withLocalizeAwareIframe from 'pages/utils/withLocalizeAwareIframe';
import withRouteAwareIframe from 'pages/utils/withRouteAwareIframe';
import withValidSessionIframe from 'pages/utils/withValidSessionIframe';
import { paths } from './routes';

class SuppliersIframe extends Component {
  componentDidMount() {
    window.merchantos.asyncSubscribe.notifySubscribers('react.mount.topbar', {
      props: {
        crumbs: [
          {
            text: 'Supplier Market',
            name: 'marketplace',
          },
        ],
      },
    });
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const segment = window.location.pathname.replace(paths.suppliers, '');
    const uriComponent = encodeURIComponent(segment);

    return (
      <Fragment>
        <style
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `.react-page { height: 100% }`,
          }}
        />
        <iframe
          title="suppliers market"
          src={`/webapps_redirect.php?app=retail-supplier&next=${uriComponent}`}
          style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
        />
      </Fragment>
    );
  }
}

export default withLocalizeAwareIframe(
  withRouteAwareIframe(withValidSessionIframe(SuppliersIframe))
);
